import React, {useCallback, useState} from "react";
import {Card, Col, OverlayTrigger, Row, Tooltip, Button, Table} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import {deleteProduct as onDeleteProduct} from "../../../slices/product/thunk";
import {useDispatch} from "react-redux";
import {DeleteModal} from "../../../Common/DeleteModal";

const ShoppingInformation = (props: any) => {
    const navigate = useNavigate();
    const {productData} = props;

    const [show, setShow] = useState<boolean>(false);
    const [delet, setDelet] = useState<any>('');

    const dispatch = useDispatch<any>();

    //delete modal state
    const handleCloseDelete = () => setShow(!show);

    const handleDeleteShow = useCallback((product: any) => {
        setDelet(product);
        setShow(!show);
    }, [show]);

    //delete modal
    const deleteModalFunction = async () => {
        const response = await dispatch(onDeleteProduct(delet.id));
        if (response) {
            navigate(`/products`);
        }
        handleCloseDelete();
    };

    return (
        <React.Fragment>
            <Col xxl={8}>
                <Row className="g-0">
                    <Col xxl={8}>
                        <Card className="rounded-end-0">
                            <Card.Body className="p-4">
                                <p className="text-muted float-md-end mb-md-0">
                                    <Link to="#"><i className="ph-storefront align-middle me-1"></i> Visit Store</Link>
                                </p>
                                <h4 className="text-capitalize mb-3">{productData.name ? productData.name : ""}</h4>
                                <div className="hstack gap-3 flex-wrap mb-4">
                                    <div className="text-muted">
                                        Brand: <b
                                        className="text-body fw-medium">{productData.brandDto ? productData.brandDto.name : ""}</b>
                                    </div>
                                    <div className="vr"></div>
                                    <div className="text-muted">
                                        CreateAt : <span
                                        className="text-body fw-medium">{productData.createdAt ? productData.createdAt : ""}</span>
                                    </div>
                                    <div className="vr"></div>
                                    <div className="text-muted">
                                        UpdateAt : <span
                                        className="text-body fw-medium">{productData.createdAt ? productData.createdAt : ""}</span>
                                    </div>

                                    <div className="vr"></div>
                                    <div className="text-muted">
                                        Category: <span
                                        className="text-body fw-medium">{productData.categoryDto ? productData.categoryDto.name : ""}</span>
                                    </div>
                                    <div className="vr"></div>
                                    <div className="text-muted">
                                        Model: <span
                                        className="text-body fw-medium">{productData.model ? productData.model.code : ""}</span>
                                    </div>
                                </div>

                                <h6 className="fs-md mb-3">Choose Size:</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {productData.variants && productData.variants.map((variant: any, index: any) => (
                                        <OverlayTrigger
                                            key={index}
                                            placement="top"
                                            overlay={<Tooltip
                                                id="tooltip-top"> {variant.attributeDto && variant.attributeDto.name}</Tooltip>}>
                                            <Link to="/product-details?id=7"
                                                  className="btn btn-sm btn-subtle-primary d-flex justify-content-center align-items-center">{variant.attributeDto && variant.attributeDto.value}</Link>
                                        </OverlayTrigger>
                                    ))}
                                </div>

                                <div className="mt-4">
                                    <h5 className="fs-md mb-3">Colors :</h5>
                                    <div className="d-flex flex-wrap gap-2">
                                        {productData.variants && productData.variants.map((variant: any, index: any) => (
                                            <OverlayTrigger
                                                placement="top"
                                                key={index}
                                                overlay={
                                                    <Tooltip
                                                        id="tooltip-top">{variant.colorDto && variant.colorDto.name}</Tooltip>
                                                }>
                                                <div>
                                                    <Link
                                                        to="button"
                                                        className="btn avatar-xs p-0 d-flex align-items-center justify-content-center border rounded-circle fs-5xl"
                                                        style={{color: variant.colorDto && variant.colorDto.heh}} >
                                                        <i className="ri-checkbox-blank-circle-fill"></i>
                                                    </Link>
                                                </div>
                                            </OverlayTrigger>
                                        ))}
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <h5 className="fs-md mb-3">Payments:</h5>

                                    <div className="hstack gap-2 flex-wrap mb-4">
                                        {productData.instalments && productData.instalments.map((item: any, index: any) => (
                                            <div key={index} className={"hstack flex-wrap gap-2"}>
                                                <div className="text-muted">
                                                    price: <b className="text-body fw-medium">{item.price}$ </b> -
                                                    Months: <b className="text-body fw-medium">{item.months} </b>
                                                </div>

                                                {productData.instalments && (productData.instalments.length - 1) === index ? "" :
                                                    <div className="vr"></div>}
                                            </div>
                                        ))}
                                    </div>

                                </div>

                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xxl={4}>
                        <Card className="card-height-100 border-start rounded-start-0">
                            <Card.Body className="p-4">
                                <Row>
                                    <Col lg={12}>
                                        <Card bg="primary">
                                            <Card.Body className="d-flex align-items-center flex-wrap gap-2">
                                                <div className="flex-grow-1">
                                                    <Card.Title className="text-white fs-xl">0% Off</Card.Title>
                                                    <p className="mb-0 text-white-50">If order over $120</p>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    <Button type="button" variant="secondary">No Discount</Button>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg={12}>
                                        <Row className="g-3">
                                            <Col md={6}>
                                                <Card className="border shadow-none mb-0">
                                                    <Card.Body className="p-2">
                                                        <div className="text-center">
                                                            <p className="text-muted text-truncate mb-2">CURRENCY</p>
                                                            <h6 className="fs-lg">{productData.currency}</h6>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={6}>
                                                <Card className="border shadow-none mb-0">
                                                    <Card.Body className="p-2">
                                                        <div className="text-center">
                                                            <p className="text-muted text-truncate mb-2">PRICE</p>
                                                            <h6 className="fs-lg">{productData.basePrice}$</h6>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={6}>
                                                <Card className="border shadow-none mb-0">
                                                    <Card.Body className="p-2">
                                                        <div className="text-center">
                                                            <p className="text-muted text-truncate mb-2">DISCOUNT</p>
                                                            <h6 className="fs-lg">{productData.discount && productData.discount.value}%</h6>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col md={6}>
                                                <Card className="border shadow-none mb-0">
                                                    <Card.Body className="p-2">
                                                        <div className="text-center">
                                                            <p className="text-muted text-truncate mb-2">QUANTITY</p>
                                                            <h6 className="fs-lg">{productData.quantity}</h6>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <div className="mt-4 d-flex gap-2">
                                    <Button
                                        type="button"
                                        variant="primary"
                                        className="w-100"
                                        onClick={() => navigate(`/create-product/?id=${productData.id}`)}
                                    >Edit</Button>
                                    <Button
                                        type="button"
                                        variant="danger"
                                        className="w-100"
                                        onClick={() => {
                                            handleDeleteShow(productData);
                                        }}>
                                        <i className="ph-trash align-middle me-1"></i> Delete
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Card>
                    <Card.Body className="p-4">
                        <div>
                            <h5 className="fs-md mb-3">Attributes:</h5>
                            <hr/>
                        </div>

                        <div className="mt-4">
                            <Row className="g-3">
                                {productData.attributes && productData.attributes.map((item: any, index: any) => (
                                    <Col lg={6} key={index}>
                                        <Row>
                                            <Col className={"d-flex align-items-center gap-2"}>
                                                <p className={"m-0"}><b>{item.name}</b></p>
                                                <div style={{
                                                    border: "0.5px dashed #dde1ef",
                                                    flexGrow: 1,
                                                    height: "0px"
                                                }}></div>
                                            </Col>
                                            <Col>
                                                <p className={"m-0"}>{item.value}</p>
                                            </Col>

                                        </Row>
                                    </Col>
                                ))}

                            </Row>

                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <DeleteModal show={show} handleClose={handleDeleteShow} deleteModalFunction={deleteModalFunction}/>
        </React.Fragment>
    );
}

export default ShoppingInformation;